import { Button, Drawer } from '@servicetitan/design-system';

import DiagnosticsModule from '..';
import datetime from '../../../lib/utils/datetime';
import useDiagnostics from '../hooks/useDiagnostics';

const DiagnosticsDrawer = () => {
  const { errors, events, drawerOpen } = useDiagnostics();

  const handleDiagnosticsDrawerClose = () => {
    DiagnosticsModule.markErrorsAsRead();
    DiagnosticsModule.setDiagnosticsDrawerOpen(false);
  };

  const handleClear = () => {
    DiagnosticsModule.clearItems();
  };

  const combined = [...errors, ...events].sort(
    (a, b) => b.createdAt - a.createdAt,
  );

  return (
    <Drawer
      header='Diagnostics'
      backdrop
      open={drawerOpen}
      onClose={handleDiagnosticsDrawerClose}
      footer={<Button onClick={handleClear}>Clear</Button>}
    >
      <div>
        {combined.map((item, index) => (
          <div
            key={index}
          >{`${datetime(item.createdAt).format('D/M h:mma')} [${item.type}]: ${item.message}`}</div>
        ))}
      </div>
    </Drawer>
  );
};

export default DiagnosticsDrawer;
